export default defineNuxtRouteMiddleware(() => {
    const auth = useAuthStore();
    if (!auth.isLogged) return;

    if (auth.isSeller) return;

    if (auth.isAdmin) {
        return navigateTo("/tat/admin/Dashboard");
    }

    if (auth.isPicker) {
        return navigateTo("/tat/picker/Pedidos");
    }

    if (auth.isCourier) {
        return navigateTo("/tat/transportista/Pedidos");
    }

    return navigateTo("/");
});
